import { render, staticRenderFns } from "./BacklinksLists.vue?vue&type=template&id=22ddd500&scoped=true"
import script from "./BacklinksLists.vue?vue&type=script&lang=js"
export * from "./BacklinksLists.vue?vue&type=script&lang=js"
import style0 from "./BacklinksLists.vue?vue&type=style&index=0&id=22ddd500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ddd500",
  null
  
)

export default component.exports